type Env = "staging" | "production";

const env: Env = (process.env.REACT_APP_ENV_NAME as Env) || "staging";

export type { Env };
export { env };
